<!-- Zones Section with Grid Layout -->
<div class="zones-grid-container" [ngClass]="isHandset()? 'overflow-y-auto' : 'overflow-x-auto'"
    [id]="'zones-container-' + parkingAreaId">
    <!-- Existing zones in grid layout -->
    @for (zone of zones; track zone.id) {
    <div class="zone-grid-item">
        <app-parking-zone-item [zone]="zone" (detailsClicked)="onZoneDetails(zone.id || '')"
            (editClicked)="onZoneEdit(zone.id || '')" (deleteClicked)="onZoneDelete(zone.id || '')"
            (unassignClicked)="onZoneUnassign(zone.id || '')">
        </app-parking-zone-item>
    </div>
    }

    @if(isAdmin()) {
    <!-- New Zone Card -->
    <div class="zone-grid-item new-zone-card border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-gray-400 transition-colors cursor-pointer group"
        (click)="onNewZone()">
        <div class="flex flex-col items-center justify-center h-full text-center">
            <div
                class="w-12 h-12 rounded-full bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center mb-2 transition-colors">
                <svg class="h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
            </div>
            <span class="text-sm text-gray-500 group-hover:text-gray-600 font-medium">New zone</span>
        </div>
    </div>
    }
</div>